import { IPromise } from 'angular';
import * as _ from 'underscore';
import { IUpdateScheduleParams, UpdateScheduleRequest } from '../../backgroundJob/types/UpdateScheduleRequest';
import { CreateScheduleRequest, ICreateScheduleParams, ICreateScheduleResult } from '../../schedule/types/CreateScheduleRequest';
import { DeleteSchedulesRequest } from '../../schedule/types/DeleteSchedulesRequest';
import { GetSchedulesRequest, IGetSchedulesResult } from '../../schedule/types/GetSchedulesRequest';
import { IScheduleInfo } from '../../schedule/types/IScheduleInfo';

import { Filter } from '../helpers/Filter';
import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import { Module } from '../Module';
import { RunSchedulesRequest } from '../ServerApi/requests/RunSchedulesRequest';
import { RunServerSchedulesRequest } from '../ServerApi/requests/RunServerSchedulesRequest';
import { SetEnabledStatusForSchedulesRequest } from '../ServerApi/requests/SetEnabledStatusForSchedulesRequest';
import { SetScheduleNameRequest } from '../ServerApi/requests/SetScheduleNameRequest';
import { FilterFieldNames, IValuedFieldFilterClause } from '../ServerApi/types/IFilterClause';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { FetcherFactory } from '../services/FetcherFactory';
import { Resource } from './Resource';

// Consider applying same migration approach as in src\userManagement\services\resources\Users.ts
export class Schedules extends Resource<IScheduleInfo> {

  public static filterByActionType(scheduledActionType: string): IValuedFieldFilterClause<string> { // ScheduleActions
    return Filter.fieldEq(FilterFieldNames.scheduledAction, scheduledActionType);
  }

  public static $inject = ['FetcherFactory'];

  constructor(FetcherFactory: FetcherFactory) {
    super(FetcherFactory.getServerResourceFetcher(
      GetSchedulesRequest,
      (result: IGetSchedulesResult) => {
        return result.schedules.map((schedule) => {
          return {
            ...schedule,
            contentType: 'schedule'
          };
        });
      }
    ));
  }

  public getByIdForSite(id: string, siteId?: string) {
    return this.getById(id, _(siteId).isString() ? [ Filter.fieldEq(FilterFieldNames.siteId, siteId) ] : []);
  }

  private setEnabledStatus(ids: string[], status: boolean): IPromise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetEnabledStatusForSchedulesRequest(idsBlock, status)),
      ResultHelper.combineResults);
  }

  public disable(ids: string[]): IPromise<IResult> {
    return this.setEnabledStatus(ids, false);
  }

  public enable(ids: string[]): IPromise<IResult> {
    return this.setEnabledStatus(ids, true);
  }

  public del(ids: string[]): IPromise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new DeleteSchedulesRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  public runServer(ids: string[]): IPromise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new RunServerSchedulesRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  public run(ids: string[]): IPromise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new RunSchedulesRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  public create(schedule: ICreateScheduleParams): IPromise<ICreateScheduleResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new CreateScheduleRequest(schedule));
  }

  public update(schedule: IUpdateScheduleParams): IPromise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new UpdateScheduleRequest(schedule));
  }

  public rename(id: string, newName: string): IPromise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new SetScheduleNameRequest(id, newName));
  }

}

Module.instance().service('Schedules', Schedules);
